type AuthorLike = {
  firstName?: string;
  secondName?: string;
  surname?: string;
  email?: string;
  _id?: string;
  id?: string;
} | string | null | undefined;

/** Resolve author id from a populated user, raw ObjectId, or missing ref. */
export function getAuthorIdFromRef(author: AuthorLike): string {
  if (!author) return "";
  if (typeof author === "string") return author;
  return author._id || author.id || "";
}

/** Prefer snapshot name, then populated user fields. */
export function getContributorDisplayName(
  author: AuthorLike,
  authorDisplayName?: string | null,
): string {
  if (authorDisplayName?.trim()) return authorDisplayName.trim();
  if (!author || typeof author === "string") return "Unknown Author";

  const firstName = author.firstName || "";
  const secondName = author.secondName || "";
  const surname = author.surname || "";
  const fullName = [firstName, secondName, surname]
    .filter((part) => part && part.trim())
    .join(" ")
    .trim();

  if (fullName) return fullName;
  if (author.email) return author.email.split("@")[0];
  return "Unknown Author";
}

/** Comment list: first name plus last-name initial (e.g. "Anna S."). */
export function getCommentAuthorDisplayName(
  author: AuthorLike,
  authorDisplayName?: string | null,
): string {
  if (authorDisplayName?.trim()) {
    return formatFirstNameWithLastInitial(authorDisplayName.trim());
  }
  if (!author || typeof author === "string") return "User";

  const firstName = (author.firstName || "").trim();
  const surname = (author.surname || "").trim();

  if (firstName || surname) {
    return formatFirstNameWithLastInitialFromParts(firstName, surname);
  }

  if (author.email) return author.email.split("@")[0];
  return "User";
}

function formatFirstNameWithLastInitial(fullName: string): string {
  const parts = fullName.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "User";
  if (parts.length === 1) return parts[0];

  const firstName = parts[0];
  const surname = parts[parts.length - 1];
  return formatFirstNameWithLastInitialFromParts(firstName, surname);
}

function formatFirstNameWithLastInitialFromParts(
  firstName: string,
  surname: string,
): string {
  if (!firstName && !surname) return "User";
  if (!surname) return firstName || "User";
  if (!firstName) return `${surname.charAt(0).toUpperCase()}.`;

  return `${firstName} ${surname.charAt(0).toUpperCase()}.`;
}
